import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges  } from '@angular/core';

interface PresaisieNode {
  name: string;
  children: PresaisieNode[];
  expanded?: boolean;
}

export interface PresaisieActionEvent {
  action: 'replace' | 'concat';
  value: string;
}

@Component({
  selector: 'frg-presaisie-maquette',
  templateUrl: './presaisie-maquette.fragment.html',
  styleUrls: ['./presaisie-maquette.fragment.scss']
})

export class PresaisieMaquettefragment {
  @Input() ligneSelectionnee: any;
  @Input() opened = false;

  @Output() valueDblClick = new EventEmitter<{node: PresaisieNode;value: string;}>();
  @Output() presaisieAction = new EventEmitter<PresaisieActionEvent>();
  @Output() openedChange = new EventEmitter<boolean>();

  public valeursPresaisie: PresaisieNode[] = [];

  ngOnChanges(changes: SimpleChanges): void {

    if (!changes.ligneSelectionnee) {
      return;
    }

    if (
      this.ligneSelectionnee?.typeCritere === 'alphanumerique'
      && this.ligneSelectionnee?.aideSaisie
    ) {
      try {
        this.valeursPresaisie =
          JSON.parse(this.ligneSelectionnee.aideSaisie) || [];
      } catch (e) {
        console.error('Erreur parsing aideSaisie :', e);
        this.valeursPresaisie = [];
      }
    } else {
      this.valeursPresaisie = [];
    }
  }

  public togglePanel(): void {
    this.opened = !this.opened;
    this.openedChange.emit(this.opened);
  }

  public toggleNode(node: PresaisieNode,event: MouseEvent): void {
    event.stopPropagation();
    node.expanded = !node.expanded;
  }

  public onValueDblClick(node: PresaisieNode,path: string[],event: MouseEvent): void {
    event.stopPropagation();
    const fullPath = [...path, node.name];
    const value = fullPath.join(' ');
    this.valueDblClick.emit({node,value});
  }

  public buildPath(path: string[], nodeName: string): string[] {
    return [...path, nodeName];
  }

  public onActionClick( action: 'replace' | 'concat', node: PresaisieNode, path: string[], event: MouseEvent ): void {

    event.stopPropagation();
    const value = [...path, node.name].join(' ');
    this.presaisieAction.emit({
      action,
      value
    });
  }

  public get collapsed(): boolean {
    return !this.opened;
  }

}
